import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from "@mui/material";

export default function AskForChangesDialog({
  open,
  onClose,
  optionEvent,
  setOptionEvent,
  onConfirm,
}) {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Edit recurring event</DialogTitle>
        <DialogContent>
          <FormControl>
            <RadioGroup
              name="event-options"
              value={optionEvent}
              onChange={(e) => setOptionEvent(e.target.value)}
            >
              <FormControlLabel
                value="single"
                control={<Radio size="small" />}
                label="This Event"
              />
              <FormControlLabel
                value="following"
                control={<Radio size="small" />}
                label="This and Following Events"
              />
              <FormControlLabel
                value="all"
                control={<Radio size="small" />}
                label="All Events"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              onClose();
              onConfirm();
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
